import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import zhCN from "antd/es/locale/zh_CN";
import { ConfigProvider } from "antd";
import "@zero/micro-app";
const AppView = (
  <ConfigProvider locale={zhCN}>
    <App />
  </ConfigProvider>
);
ReactDOM.render(AppView, document.getElementById("root"));
